// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--colorRed:#ef3438;--colorGrey:#4a4b65;--colorGreen:#16c995;--colorPurple:#766df4;--colorOrange:#ffbd5c;--colorDarkGrey:#37384e;--colorLightGrey:#737491;--colorDarkerRed:#d35b5e;--colorLightPurple:#f7f7fc;--colorDarkerGreen:#10936d;--colorDarkerPurple:#493ef0;--colorDarkerOrange:#dfa44e}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
